import * as React from 'react';
import {Shop} from 'interfaces';
import {Flex, Text} from 'components/UIKit';
import {ListingCard} from '../ListingCard';
import {ViewToggleButtons} from './components';
import styles from './ListingCards.scss';

export interface ListingCardsProps {
  shops: Shop[];
  group?: string;
  loading?: boolean;
  countString?: string;
}

interface ListingCardsState {
  showImage: boolean;
}

export class ListingCards extends React.Component<ListingCardsProps, ListingCardsState> {
  state: ListingCardsState = {
    showImage: true,
  };

  toggleViewClick = () => {
    const {showImage} = this.state;
    this.setState({showImage: !showImage});
  };

  render() {
    const {shops, group, loading, countString = null} = this.props;
    const {showImage} = this.state;
    const showCountString = Boolean(countString);

    return (
      <>
        <Flex alignItems="center" justifyContent={showCountString ? 'space-between' : 'flex-end'}>
          {showCountString && <Text text={countString} component="p" />}
          <ViewToggleButtons
            activeView={showImage ? 'image' : 'graph'}
            onToggleClick={this.toggleViewClick}
          />
        </Flex>
        <ul className={styles.ListingCards}>
          {shops.map((shop) => (
            <ListingCard
              key={shop.handle}
              shop={shop}
              group={group || ''}
              loading={loading}
              showImage={showImage}
            />
          ))}
        </ul>
      </>
    );
  }
}
